import { isValidElement } from "react";

export function useWrapper(wrapper, defaultWrapper) {
	const isWrapperElement = isValidElement(wrapper);
	const Wrapper = isWrapperElement ? wrapper.type : defaultWrapper;
	const wrapperProps = isWrapperElement ? wrapper.props : {};

	return { Wrapper, wrapperProps };
}
